import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ChqWidgetsButtonModel } from 'src/app/model/chq-widgets-button-model';
import { ChqWidgetsInputModel, IControlValue } from 'src/app/model/chq-widgets-input-model';
import { CommonService } from 'src/app/services/common/common.service';
import { SupplierService } from 'src/app/services/supplier/supplier.service';

@Component({
    selector: 'app-supplier-approval',
    templateUrl: './supplier-approval.component.html',
    styleUrls: ['./supplier-approval.component.scss'],
    standalone: false
})
export class SupplierApprovalComponent implements OnInit {


  public approveRadio: ChqWidgetsInputModel = {
    placeHolder: 'approve',
    label: 'approve',
    name: 'approve',
    idField: '',
    value: '1',
    type: 'radio',
    hideLabel: true,
    options: [ { label: 'approve', id: 1 } ]
  }

  private urlToken: string = '';
  public checkedStatus = '';
  public status = '';
  public partnershipGuid = '';
  public orgId = 0;
  public bodyshopName = '';

  public cancelled: boolean = false;
  public success: boolean = false;

  public declineRadio: ChqWidgetsInputModel = {
    placeHolder: 'decline',
    label: 'decline',
    name: 'decline',
    idField: '',
    value: '2',
    type: 'radio',
    hideLabel: true,
    options: [ { label: 'decline', id: 2 } ]
  }

  public cancelButtonModel: ChqWidgetsButtonModel = {
    label: 'cancel',
    type: 'outline'
  }
  public nextButtonModel: ChqWidgetsButtonModel = {
    label: 'send',
    type: 'disabled'
  }

  /**
    Constructor for the component.
    @param {CommonService} commonService - The CommonService instance.
    @param {BookingService} repairEstimateService - The RepairEstimateService instance.
    @param {ActivatedRoute} route - The ActivatedRoute instance.
  */
  constructor(
    public commonService: CommonService,
    private readonly route: ActivatedRoute,
    private readonly supplierService: SupplierService,
    public translate: TranslateService
  ,
    private readonly cdr: ChangeDetectorRef) {

  }

  /**
   * cancelled
   */
  cancel(): void {
    this.cancelled = true;
  }

  /**
   * approve/reject repair
   */
  updateSupplierStatus(): void {
    const status = this.checkedStatus === 'Approved' ? 'Approved' : 'Rejected';
    this.status = status;
    this.commonService.showLoading();

    const body = {
      status: status,
    }

    this.supplierService.activateSupplier(body, this.partnershipGuid, this.orgId, this.urlToken).subscribe({ 
      next: () => {
        this.success = true;
        this.commonService.hideLoading();
        this.cdr.detectChanges();
      },
      error: () => {
        this.commonService.hideLoading();
        this.cdr.detectChanges();
      } 
    })

  }

  /**
   * on init
   */
  ngOnInit(): void {
    this.commonService.dismissBootstrapLoader();
    this.urlToken = this.route?.snapshot?.queryParams['token'];
    this.partnershipGuid = this.route?.snapshot?.paramMap?.get('partnershipGUID');
    this.orgId = +this.route?.snapshot?.paramMap?.get('orgId');
    this.bodyshopName = this.route?.snapshot?.paramMap?.get('bodyshopName');
    this.nextButtonModel = { ...this.nextButtonModel, onclick: this.updateSupplierStatus.bind(this) };
    this.cancelButtonModel = { ...this.cancelButtonModel, onclick: this.cancel.bind(this) };
  }

  /**
   * onFormUpdate
   */
  onFormUpdate($event: IControlValue): void {
    const { name, value } = $event;
    if (name === 'approve') {
      if (this.declineRadio.value !== 2 && value) {
        this.checkedStatus = 'Approved';
        this.nextButtonModel = { ...this.nextButtonModel, type: 'primary' };
        this.declineRadio = { ...this.declineRadio, value: '' };
      }
    } else if (name === 'decline') {
      if (this.approveRadio.value !== 1 && value) {
        this.checkedStatus = 'declined';
        this.nextButtonModel = { ...this.nextButtonModel, type: 'primary' };
        this.approveRadio = { ...this.approveRadio, value: '' };
      }
    }
  }
}
